module.exports = __webpack_public_path__ + "img/vk-invite.b03024c4.svg";